import React, { useState } from "react";
import "./LeftDrawer.scss"
import close from "../../assets/close.svg"
import Button from "../Button/Button";
import arrow from "../../assets/down-arrow.svg"
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";

const LeftDrawer = ({ isOpen, setIsOpen }) => {
    const [showSubmenu, setShowSubmenu] = useState("")

    const history = useHistory()
    const dispatch = useDispatch()
    const pages = useSelector((state) => state.companyData.pages)
    const company = useSelector((state) => state.companyData.company);

    const page = pages?.find((page) => page.PageId === "navbar")
    const linksComponent = page?.Components?.find((component) => component?.ID === "Hoppers-Navbar-link")?.Data ?? []
    const buttonComponent = page?.Components?.find((component) => component?.ID === "Hoppers-Navbar-button")?.Props ?? null

    return (
        <div className="HoppersCafeLeftDrawer">
            <div className={`HoppersCafeLeftDrawer-left-drawer ${isOpen ? 'open' : ''}`}>
                <div className={`HoppersCafeLeftDrawer-left-drawer-header`}>
                    <img alt="" src={close}
                        onClick={() => {
                            setIsOpen(false)
                            setShowSubmenu("")
                        }} />
                </div>
                <div className={`HoppersCafeLeftDrawer-left-drawer-content`}>
                    {linksComponent.map((page, key) => {
                        return (
                            <>
                                <div className={`HoppersCafeLeftDrawer-left-drawer-content-pages  ${window.location.pathname === page?.href ? "HoppersCafeLeft-link-selected " : ""}`} key={key}
                                    onClick={() => {
                                        if (page?.subMenu && page?.subMenu.length > 0) {
                                            if (showSubmenu === "") {
                                                setShowSubmenu(page?.title)
                                            } else {
                                                setShowSubmenu("")
                                            }
                                        } else {
                                            setIsOpen(false)
                                            if (page?.href) {
                                                if (page?.href?.includes("https://")) {
                                                    if (page?.href && page?.href !== "") {
                                                        window.open(page?.href, '_blank')
                                                    }
                                                    else {
                                                        dispatch(setIsComing(true))

                                                    }
                                                } else {
                                                    history.push(page?.href)
                                                }
                                            } else {
                                                dispatch(setIsComing(true))
                                            }
                                        }
                                    }}>
                                    {page?.title}
                                    {page?.subMenu && page?.subMenu.length > 0 && <img
                                        alt="" src={arrow} />}

                                </div>
                                {showSubmenu === page.title && <div className={`HoppersCafeLeftDrawer-left-drawer-content-pages-sub`}
                                >
                                    {page?.subMenu?.map((submenu, key) => {
                                        return (<div key={key}
                                            className={`drawer-popup-cont-item  ${window.location.pathname === submenu?.href ? "HoppersCafeLeft-link-selected " : ""}`}
                                            onClick={() => {
                                                setShowSubmenu("")
                                                history.push(submenu?.href)
                                                setIsOpen(false)
                                            }}>{submenu.title}
                                        </div>)
                                    })}
                                </div>}
                            </>
                        )
                    })}
                    {buttonComponent && <div className={`HoppersCafeLeftDrawer-left-drawer-content-btn`}>

                        <Button
                            text={buttonComponent?.buttonText}
                            onClick={() => {
                                if (buttonComponent?.href && buttonComponent?.href !== "") {
                                    window.open(buttonComponent?.href, '_blank')
                                } else {
                                    dispatch(setIsComing(true))
                                }
                            }} />
                    </div>}
                </div>
                <div className="HoppersCafeLeftDrawer-left-drawer-bottm">
                    <div className="HoppersCafeLeftDrawer-left-drawer-bottm-header">
                        ADDRESS
                    </div>
                    <div className="HoppersCafeLeftDrawer-left-drawer-bottm-item">
                        25 Station Street, Kirkby-in-Ashfield (NG17 7AQ)
                    </div>
                    <div className="HoppersCafeLeftDrawer-left-drawer-bottm-item2">
                        P: <b>+44 1784 463978</b>
                    </div>
                    <div className="HoppersCafeLeftDrawer-left-drawer-bottm-item2">
                        E: <b> Akash@hoppersandlatte.com</b>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default LeftDrawer